import { render, staticRenderFns } from "./StatusSetter.vue?vue&type=template&id=bb06b3a6&scoped=true"
import script from "./StatusSetter.vue?vue&type=script&lang=ts"
export * from "./StatusSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb06b3a6",
  null
  
)

export default component.exports